<template>
  <v-card>
    <!-- <Stepper :step="step"></Stepper> -->
    <v-stepper class="layout wrap" v-model="counter.count" alt-labels>
      <v-stepper-header class="flex xs12 md8 offset-md2">

        <template v-for="(step, index) in steps">
          <v-stepper-step
            :key="index + 1"
            :step="index + 1"
            :complete="counter.count > (index + 1)"
            color="success"
          >
            {{ step.title }}
          </v-stepper-step>
          <v-divider
            :key="`step-divider-${index + 1}`"
            v-if="index + 1 < steps.length"
          ></v-divider>
        </template>

      </v-stepper-header>
    </v-stepper>

    <div class="text-center pt-5">
      <div class="d-block">
        <v-btn
          :elevation="0"
          rounded
          color="primary"
          class="mb-2"
          @click="incStep(counter.count)"
          v-html="counter.title"
        ></v-btn>
      </div>
    </div>

    <Intro v-if="counter.count === 1"></Intro>
    <v-row v-if="counter.count === 2" wrap>
      <v-col cols="12" lg="6">
        <!-- Profile user infos -->
        <Profile></Profile>
        <!-- Firm list -->
        <StaffList></StaffList>
      </v-col>
      <!-- Firm list -->
      <v-col cols="12" lg="6">
        <FirmList></FirmList>
      </v-col>
    </v-row>

    <div class="text-center pt-5">
      <div class="d-block">
        <v-btn
          :elevation="0"
          rounded
          color="primary"
          class="mb-2"
          @click="incStep(counter.count)"
          v-html="counter.title"
        ></v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import Intro from '@/components/app/onboarding/Intro'
import Profile from '@/components/profile/Profile'
import FirmList from '@/components/firm/FirmList'
import StaffList from '@/components/profile/staff/StaffList'

export default {
  components: {
    Intro: Intro,
    Profile: Profile,
    FirmList: FirmList,
    StaffList: StaffList
  },

  data () {
    return {
      counterInfos: {
        1: {
          count: 1,
          title: this.$t('welcome.btn-1')
        },
        2: {
          count: 2,
          title: this.$t('welcome.btn-2'),
          to: '/dashboard'
        }
      },
      counter: {
        count: 1,
        title: this.$t('welcome.btn-1')
      },
      steps: [
        { title: this.$t('welcome.title-1') },
        { title: this.$t('welcome.title-2') },
        { title: this.$t('welcome.title-3') }
      ]
    }
  },

  methods: {
    incStep (nextCount) {
      if (this.counter.to) {
        this.$router.push(this.counter.to)
      } else if (this.counterInfos[nextCount+1]) {
        this.counter = this.counterInfos[nextCount+1]
      } else { return }
    }
  }
}
</script>
